import React from "react";
import { Container, ParagraphContainer } from "./styles";
import SubHeader from "../../components/SubHeader";
import HelmetCustom from "../../components/HelmetCustom";
import ReactHtmlParser from "react-html-parser";
import { useSelector } from "react-redux";
import MainLayout from "../../components/MainLayout";

export default function TermsOfUse({ history }) {

  const { termos_uso } = useSelector((state) =>
    state.store.data == null ? "" : state.store.data.empresa
  );

  return (
    <MainLayout history={history}>
      <HelmetCustom pageTitle="Políticas de Privacidade" />
      <SubHeader
        title="Nossas Políticas"
        withBackButton
        withDescription
        description="Central de informações"
      />
      <Container>

        <ParagraphContainer>
          {ReactHtmlParser(termos_uso)}
        </ParagraphContainer>

      </Container>
    </MainLayout>
  );
}
